import { ErrorBoundary, LoggerProvider } from '@ori/logger';
import { TestIdProvider } from '@ori/testid-generator';
import type { FC } from 'react';
import { Suspense } from 'react';

import { APP_NAME, APP_TEAM_NAME } from '../constants';
import type { NovageSkincareAdvisorProviderProps } from '../contexts';
import { NovageSkincareAdvisorProvider } from '../contexts';
import { mainLogger } from '../logger';
import { ApiProvider } from './ApiProvider';
import { NovageSkincareAdvisor } from './NovageSkincareAdvisor';

export type NovageSkincareAdvisorControllerProps = Pick<NovageSkincareAdvisorProviderProps, 'translations'>;

/**
 * Accepts config data, renders NovageSkincareAdvisor.
 */
export const NovageSkincareAdvisorController: FC<NovageSkincareAdvisorControllerProps> = ({ translations }) => (
  <Suspense fallback={null}>
    <TestIdProvider
      team={APP_TEAM_NAME}
      project={APP_NAME}
    >
      <LoggerProvider logger={mainLogger}>
        <ErrorBoundary areaName="NovageSkincareAdvisorController">
          <ApiProvider>
            <NovageSkincareAdvisorProvider translations={translations}>
              <NovageSkincareAdvisor />
            </NovageSkincareAdvisorProvider>
          </ApiProvider>
        </ErrorBoundary>
      </LoggerProvider>
    </TestIdProvider>
  </Suspense>
);
